import { BrowserRouter, Route } from "react-router-dom";
import LandingPage from "./components/landing/LandingPage";
import DriverLandingPage from "./components/landing/DriverLandingPage";
import BusinessRegistrationPage from "./components/business/BusinessRegistrationPage";
import BusinessLoginPage from "./components/business/BusinessLoginPage";
import TransactionsPage from "./components/business/BusinessTransactionsPage";
import BusinessADPage from "./components/business/BusinessADPage";
import BusinessDashboardPage from "./components/business/BusinessDashboardPage";
import BusinessBuyAirtimePage from "./components/business/BusinessBuyAirtimePage";
import BusinessDepositPage from "./components/business/BusinessDepositPage";
import BusinessTermsPage from "./components/business/BusinessTermsPage";
import firebase from "./config/firebaseConfig";
import { ToastContainer } from "react-toastify";
import { connect, useSelector } from "react-redux";
import React, { Component } from "react";
import store from "./store/store";
import Loading from "./components/widgets/Loading";
import Contacts from "./components/landing/ContactsPage";
import { ReactReduxFirebaseProvider, isLoaded } from "react-redux-firebase";
import { createFirestoreInstance } from "redux-firestore";
import {
  GetBusinessProfile,
  GetBusinessSystemAccount,
  GetSystemUser,
  GetBankInfos,
  ClearProfile,
} from "./store/actions/profileActions";

class App extends Component {
  state = {};

  componentDidUpdate(prev, curr) {
    if (this.props.profile === null && this.props.auth.email !== null) {
      if (
        prev.firebase.profile.isLoaded === false &&
        !this.props.firebase.profile.isEmpty &&
        this.props.firebase.profile.isLoaded === true
      ) {
        this.props.getBusiness();
        this.props.getBusinessSystemAccount();
        this.props.getSystemUser();
        this.props.getBankInfos();
      }
    } else if (
      this.props.auth.isEmpty === true &&
      prev.auth.email !== null &&
      this.props.profile !== null
    ) {
      this.props.clearProfile();
    }
  }

  render() {
    return (
      <ReactReduxFirebaseProvider {...rrfProps}>
        <BrowserRouter>
          <AuthIsLoaded>
            <ToastContainer autoClose={3000} hideProgressBar={true} />
            {this.props.authprofile.loading ? (
              <div className="App">
                <Loading />
              </div>
            ) : (
              <div className="App">
                <Route path="/contacts" component={Contacts} />
                <Route path="/landing_page" component={LandingPage} />
                <Route path="/business_terms" component={BusinessTermsPage} />

                {!this.props.auth.uid || this.props.auth.isAnonymous ? (
                  <Route path="/business_login" component={BusinessLoginPage} />
                ) : (
                  <Route
                    path="/business_login"
                    component={BusinessDashboardPage}
                  />
                )}
                {!this.props.auth.uid || this.props.auth.isAnonymous ? (
                  <Route
                    path="/business_register"
                    component={BusinessRegistrationPage}
                  />
                ) : (
                  <Route
                    path="/business_register"
                    component={BusinessDashboardPage}
                  />
                )}
                {!this.props.auth.uid || this.props.auth.isAnonymous ? (
                  <Route
                    path="/business_transactions"
                    component={BusinessLoginPage}
                  />
                ) : (
                  <Route
                    path="/business_transactions"
                    component={TransactionsPage}
                  />
                )}
                {!this.props.auth.uid || this.props.auth.isAnonymous ? (
                  <Route path="/driver" component={DriverLandingPage} />
                ) : (
                  <Route path="/driver" component={BusinessDashboardPage} />
                )}

                {!this.props.auth.uid && this.props.auth.isAnonymous ? (
                  <Route
                    path="/business_ad/:adid"
                    component={BusinessLoginPage}
                  />
                ) : (
                  <Route path="/business_ad/:adid" component={BusinessADPage} />
                )}
                {!this.props.auth.uid && this.props.auth.isAnonymous ? (
                  <Route
                    path="/business_dashboard"
                    component={BusinessLoginPage}
                  />
                ) : (
                  <Route
                    path="/business_dashboard"
                    component={BusinessDashboardPage}
                  />
                )}
                {!this.props.auth.uid && this.props.auth.isAnonymous ? (
                  <Route
                    path="/business_buy_airtime"
                    component={BusinessLoginPage}
                  />
                ) : (
                  <Route
                    path="/business_buy_airtime"
                    component={BusinessBuyAirtimePage}
                  />
                )}
                {!this.props.auth.uid && this.props.auth.isAnonymous ? (
                  <Route
                    path="/business_deposit"
                    component={BusinessLoginPage}
                  />
                ) : (
                  <Route
                    path="/business_deposit"
                    component={BusinessDepositPage}
                  />
                )}
                {!this.props.auth.uid || this.props.auth.isAnonymous ? (
                  <Route path="/" exact={true} component={LandingPage} />
                ) : (
                  <Route
                    path="/"
                    exact={true}
                    component={BusinessDashboardPage}
                  />
                )}

                {/* //<Route path="/" exact={true} component={LandingPage} />
// 				<Route path="/business_register" component={BusinessRegistrationPage} />
// 				<Route path="/business_login" component={BusinessLoginPage} />
// 				<Route path="/business_transactions" component={TransactionsPage} />
// 				<Route path="/driver" component={DriverLandingPage} />
// 				<Route path="/business_ad_history" component={BusinessADHistoryPage} />
// 				<Route path="/business_ad" component={BusinessADPage} />
// 				<Route path="/business_dashboard" component={BusinessDashboardPage} />
// 				<Route path="/business_buy_airtime" component={BusinessBuyAirtimePage} /> */}
              </div>
            )}
          </AuthIsLoaded>
        </BrowserRouter>
      </ReactReduxFirebaseProvider>
    );
  }
}

const rrfProps = {
  firebase,
  config: {
    userProfile: "business",
    useFirestoreForProfile: true,
  },
  dispatch: store.dispatch,
  createFirestoreInstance,
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile.profile,
    firebase: state.firebase,
    authprofile: state.auth,
  };
};

function AuthIsLoaded({ children }) {
  const auth = useSelector((state) => state.firebase.auth);
  if (!isLoaded(auth)) return <Loading />;
  return children;
}

// function App(props) {
// 	return (
// 		<BrowserRouter>
// 			<div className="content">
// 				<Route path="/" exact={true} component={LandingPage} />
// 				<Route path="/business_register" component={BusinessRegistrationPage} />
// 				<Route path="/business_login" component={BusinessLoginPage} />
// 				<Route path="/business_transactions" component={TransactionsPage} />
// 				<Route path="/driver" component={DriverLandingPage} />
// 				<Route path="/business_ad_history" component={BusinessADHistoryPage} />
// 				<Route path="/business_ad" component={BusinessADPage} />
// 				<Route path="/business_dashboard" component={BusinessDashboardPage} />
// 				<Route path="/business_buy_airtime" component={BusinessBuyAirtimePage} />
// 				{/* <Route path="/su_transaction_history" component={TransactionHistoryPage} /> */}
// 				{/* <Route path="/su_transaction_graph" component={TransactionGraphPage} /> */}

// 				{/* <Route path="/cart/:id?" component={CartScreen} />
// 						<Route path="/signin" component={SignInScreen} />
// 						<Route path="/manage" component={ManageScreen} />
// 						<Route path="/register" component={RegisterScreen} />
// 						<Route path="/shipping" component={ShippingScreen} />
// 						<Route path="/payment" component={PaymentScreen} />
// 						<Route path="/placeorder" component={PlaceOrderScreen} />
// 						<Route path="/order/:id" component={OrderScreen} /> */}
// 			</div>
// 		</BrowserRouter>
// 	);
// }

const mapDispatchToProps = (dispatch) => {
  return {
    getBusiness: () => dispatch(GetBusinessProfile()),
    getBusinessSystemAccount: () => dispatch(GetBusinessSystemAccount()),
    getSystemUser: () => dispatch(GetSystemUser()),
    getBankInfos: () => dispatch(GetBankInfos()),
    clearProfile: () => dispatch(ClearProfile()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
